export const RegistryContactAreaKeys = Object.freeze({
    ADMINISTRATIVE: 'ADMINISTRATIVE',
    TECHNICAL: 'TECHNICAL'
});
